import { DetailedPaymentBatchLogFragment } from "#graphql/supergraphTypes";
import * as styles from "../../shared/LogsList/styles.css";
import { LogsListConfig } from "../../shared/LogsList/types";
import { cardTitle } from "./PaymentDetailsDisplay/styles_vanilla.css";

type PaymentBatchLog = DetailedPaymentBatchLogFragment;

/**
 * Base configuration shared between payment batch and payable logs
 */
const baseLogsConfig: Omit<LogsListConfig<PaymentBatchLog>, "formatActionDescription"> = {
  getIcon: (logEntry) => {
    if (logEntry.actionType === "DENY") {
      return "times-circle";
    }
    return "check-circle";
  },

  shouldShowReason: (logEntry) => {
    return Boolean(logEntry.reason);
  },

  getReason: (logEntry) => {
    return logEntry.reason;
  },

  reasonBoxClassName: styles.reasonBox,

  cardTitleClassName: cardTitle,

  cardTitle: undefined, // Will use default "LOG"
};

/**
 * Configuration for rendering Payment Batch logs using the generic LogsList component
 */
export const paymentBatchLogsConfig: LogsListConfig<PaymentBatchLog> = {
  ...baseLogsConfig,

  formatActionDescription: (logEntry) => {
    const userName = logEntry.user?.fullName || "Unknown User";
    const reviewUserName = logEntry.reviewUser?.fullName || "Unknown Reviewer";

    switch (logEntry.actionType) {
      case "CREATE":
        return `Payment batch created and submitted for review by ${userName}`;
      case "APPROVE":
        return `Approved by ${reviewUserName}`;
      case "DENY":
        return `Approval denied by ${reviewUserName}`;
      case "UPDATE":
      default:
        return `Payment batch updated by ${userName}`;
    }
  },
};

/**
 * Configuration for rendering Payable logs using the generic LogsList component
 */
export const payableLogsConfig: LogsListConfig<PaymentBatchLog> = {
  ...baseLogsConfig,

  formatActionDescription: (logEntry) => {
    const userName = logEntry.user?.fullName || "Unknown User";
    const reviewUserName = logEntry.reviewUser?.fullName || "Unknown Reviewer";

    switch (logEntry.actionType) {
      case "CREATE":
        return `Payment created and submitted for review by ${userName}`;
      case "APPROVE":
        return `Approved by ${reviewUserName}`;
      case "DENY":
        return `Approval denied by ${reviewUserName}`;
      case "UPDATE":
      default:
        return `Payment updated by ${userName}`;
    }
  },
};
